import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../../components-v2/Button';
import { Checkbox } from '../../../../../components-v2/Checkbox';
import { Label } from '../../../../../components-v2/Label';
import { ReminderModal } from './ReminderModal';
import { styleSheet } from './styles';

const DEFAULT_REMINDER_OPTIONS: Api.IMessageReminderOptions = {
	maxAttempts: 3,
	intervalInDays: 3,
	subject: 'Reminder: Please upload your files',
	content: Api.createRawRichTextContentStateWithHtmlStringValue(
		'<p>Please take a moment to upload your files: {{file request}}</p>'
	),
	type: Api.MessageReminderType.FileRequest,
};

interface Props {
	reminderOptions: Api.IMessageReminderOptions | undefined;
	onChange: (opts: Api.IMessageReminderOptions | undefined) => void;
	hasSubject: boolean;
	readonly?: boolean;
}

export function FileRequestReminderOptions({ reminderOptions, onChange, hasSubject, readonly }: Props) {
	const checkboxId = React.useId();
	const [isModalOpen, setIsModalOpen] = React.useState(false);
	const isEnabled = !!reminderOptions;

	const handleCheckedChange = (checked: boolean) => {
		if (checked) {
			onChange(DEFAULT_REMINDER_OPTIONS);
			setIsModalOpen(true);
		} else {
			onChange(undefined);
		}
	};

	const handleModalSave = (opts: Api.IMessageReminderOptions) => {
		onChange(opts);
		setIsModalOpen(false);
	};

	const modalOptions = reminderOptions ?? DEFAULT_REMINDER_OPTIONS;

	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.row)}>
				<Checkbox id={checkboxId} checked={isEnabled} onCheckedChange={handleCheckedChange} disabled={readonly} />
				<Label htmlFor={checkboxId}>Send file request reminder</Label>
				{isEnabled && !readonly && (
					<Button variant='secondary' onClick={() => setIsModalOpen(true)}>
						Edit reminder
					</Button>
				)}
			</div>
			{/* DialogPopup lazy-renders — children do not mount when open={false} */}
			<ReminderModal
				isOpen={isModalOpen}
				reminderOptions={modalOptions}
				hasSubject={hasSubject}
				onSave={handleModalSave}
				onRequestClose={() => setIsModalOpen(false)}
			/>
		</div>
	);
}
